import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { formatDateSmall } from "../../../../../utils/dates";
import Table from "../../../../../components/common/table/Table";
import arrowRightIcon from "../../../../../assets/images/arrow-right.svg";
import noResultsIcon from "../../../../../assets/images/empty-project.svg";
import styles from "./Completed.scss";

import { Mixpanel } from "../../../../../actions/mixpanel.actions";
import { PROJECT_INDEX_TABLE } from "../../../../../actions/project.actions";

class Completed extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const projects = _.get(this.props, "projects");

    const mappedCompleted =
      projects.length > 1 &&
      projects.map(project => {
        const dateCompleted = _.get(
          _.first(
            _.filter(project.log, log => {
              return log.status.name == "completed";
            })
          ),
          "modified_at"
        );

        return {
          rowKey: project.id,
          data: [
            {
              displayText: this.getProjectDisplayText(project),
              orderByText: project.title
            },
            {
              displayText: this.getProjectStatusText(project),
              orderByText: this.getProjectStatusText(project)
            },
            {
              displayText: formatDateSmall(dateCompleted),
              orderByText: formatDateSmall(dateCompleted)
            },
            {
              displayText: this.getButtonsDisplayText(project)
            },
            {
              displayText: "",
              sortDisable: true
            }
          ]
        };
      });

    return mappedCompleted.length > 0
      ? this.renderCompleted(mappedCompleted)
      : this.renderNoResults();
  }

  getProjectDisplayText(project) {
    const company = _.get(project, "user.profile.company") || {};

    return (
      <div className={styles.rowHeader}>
        <div>
          <Link
            to={`/member/company/${company.id}`}
            onClick={() =>
              Mixpanel.track("Member - Completed - Project Company Name")
            }
          >
            {company.name}
          </Link>
        </div>

        <div className={styles.rowHeaderSubtitle}>
          <Link
            to={`/member/project/${project.id}/detail`}
            onClick={() =>
              Mixpanel.track("Member - Completed - Project Job Title")
            }
          >
            {project.title}
          </Link>
        </div>
      </div>
    );
  }

  getProjectStatusText(project) {
    return _.get(project, "status.display_name");
  }

  getButtonsDisplayText(project) {
    let reviewSubmitted = false;

    if (!_.isEmpty(project.reviews)) {
      project.reviews.forEach(review => {
        if (review.source_id == _.get(project, "selected.member_id")) {
          reviewSubmitted = true;
        }
      });
    }

    const submitFeedback = (
      <Link
        to={`/member/review/${project.id}`}
        className={styles.blueButton}
        onClick={() => Mixpanel.track("Member - Completed - Submit Feedback")}
      >
        Submit Feedback
      </Link>
    );

    const feedbackSubmitedComponent = (
      <span className={styles.feedbackSubmitted}>Feedback Submitted</span>
    );

    const buttons = {
      completed: submitFeedback,
      reviewed: submitFeedback
    };

    return (
      <div className={styles.actionsContainer}>
        {reviewSubmitted
          ? feedbackSubmitedComponent
          : buttons[project.status.name]}

        <Link
          to={`/member/project/${project.id}/detail`}
          onClick={() => Mixpanel.track("Member - Completed - Project Arrow")}
        >
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );
  }

  renderNoResults() {
    return (
      <div className={styles.noResults}>
        <div className={styles.noResultsMsg}>
          <img
            src={noResultsIcon}
            alt="noResultsIcon"
            className={styles.noResultsIcon}
          />
          <div className={styles.noResultsMsgText}>
            <p>You have not completed any projects.</p>
          </div>
        </div>
      </div>
    );
  }

  renderCompleted(mappedCompleted) {
    const tableData = {
      headers: [
        {
          displayText: "PROJECT",
          id: "table-member-completed-sort-project",
          track: "Table - Member Completed - Sort By Project"
        },
        {
          displayText: "STATUS UPDATED",
          id: "table-member-completed-sort-status",
          track: "Table - Member Completed - Sort By Status"
        },
        {
          displayText: "DATE COMPLETED",
          id: "table-member-sows-sort-date-completed",
          track: "Table - Member Completed - Sort By Date Completed"
        }
      ],
      rows: mappedCompleted
    };

    const defaultSort = {
      headerIndex: 2,
      order: "asc"
    };

    return (
      <div className={styles.completed}>
        <h2 className={styles.pageTitle}>Completed</h2>
        <p className={styles.pageSubTitle} />

        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name={PROJECT_INDEX_TABLE}
          colsConfig={["45%", "20%", "20%", "15%"]}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }
}

export default Completed;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/completed/components/Completed.js